module.exports = __webpack_public_path__ + "static/media/about-image.cf4c8e7d.png";